import React, { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";

const SingleLinkForm = ({ formData, setFormData, availableBuilds, loading, onGenerate }) => {
  const { userType } = useContext(AuthContext);

  const selectedBuild = availableBuilds[formData.build_id];

  return (
    <div className="flex bg-white">
      <div className="flex-1 py-4">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4 sm:space-y-5">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              {/* ==========================
                 THERAPIST DROPDOWN LOGIC
                 ========================== */}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select Therapist *
                </label>

                {userType === "Therapist" ? (
                  // 🔵 THERAPIST — SHOW READONLY BOX, NOT DROPDOWN
                  <div className="p-3 border border-gray-300 bg-gray-100 rounded-md">
                    {/* <p className="text-sm text-gray-700">Assigned Therapist</p> */}
                    <p className="font-semibold text-gray-900">
                      {selectedBuild?.name || "No assigned build"}
                    </p>
                  </div>
                ) : (
                  // 🔵 ADMIN — SHOW DROPDOWN
                  <select
                    value={formData.build_id}
                    onChange={(e) =>
                      setFormData({ ...formData, build_id: e.target.value })
                    }
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-md
                               focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="">Choose a therapist...</option>

                    {Object.entries(availableBuilds).map(([id, build]) => (
                      <option key={id} value={id}>
                        {build.name}
                      </option>
                    ))}
                  </select>
                )}

                {/* Description (only if build exists) */}
                {selectedBuild && (
                  <p className="text-xs text-gray-500 mt-2">
                    {selectedBuild.description}
                  </p>
                )}
              </div>

              {/* ==========================
                 EXPIRATION INPUT
                 ========================== */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Expiration (hours)
                </label>
                <input
                  type="number"
                  min="1"
                  max="168"
                  value={formData.expiration_hours}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      expiration_hours: parseInt(e.target.value),
                    })
                  }
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-md
                             focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            {/* ==========================
               BUTTON
               ========================== */}
            <button
              onClick={onGenerate}
              disabled={loading}
              className="py-3 px-6 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 
                         text-white font-medium rounded-md transition-colors
                         shadow-sm hover:shadow-md inline-flex justify-start"
            >
              {loading ? "Generating..." : "Generate Session Link"}
            </button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleLinkForm;
